import Skeleton from "../../../../components/Skeleton/Skeleton";
import styles from "./MobileTableSkeleton.module.scss";

interface MobileTableSkeletonProps {
  rows?: number;
}

const MobileTableSkeleton = ({ rows = 5 }: MobileTableSkeletonProps) => {
  const {
    container,
    skeletonRow,
    rowHeader,
    companyData,
    iconSkeleton,
    titleGroup,
    starSkeleton,
    rowData,
    littleRows,
    dataCell,
    filtersContainer,
  } = styles;

  return (
    <div className={container}>
      <div className={filtersContainer}>
        <Skeleton width="100%" height="2.75rem" />
        <Skeleton width="2.75rem" height="2.75rem" />
      </div>
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className={skeletonRow}>
          <div className={rowHeader}>
            <div className={companyData}>
              <Skeleton
                className={iconSkeleton}
                width="3rem"
                height="3rem"
                borderRadius="0.25rem"
              />
              <div className={titleGroup}>
                <Skeleton
                  width="8rem"
                  height="0.89rem"
                  borderRadius="0.25rem"
                />
                <Skeleton
                  width="6rem"
                  height="0.89rem"
                  borderRadius="0.25rem"
                />
              </div>
            </div>
            <Skeleton
              className={starSkeleton}
              width="1.5rem"
              height="1.5rem"
              borderRadius="0.25rem"
            />
          </div>

          <div className={rowData}>
            <div className={littleRows}>
              <div className={dataCell}>
                <Skeleton
                  width="5rem"
                  height="0.79rem"
                  borderRadius="0.25rem"
                />
              </div>
              <div className={dataCell}>
                <Skeleton
                  width="4.5rem"
                  height="0.79rem"
                  borderRadius="0.25rem"
                />
              </div>
            </div>
            <div className={littleRows}>
              <div className={dataCell}>
                <Skeleton
                  width="5.5rem"
                  height="0.79rem"
                  borderRadius="0.25rem"
                />
              </div>
              <div className={dataCell}>
                <Skeleton
                  width="5rem"
                  height="0.79rem"
                  borderRadius="0.25rem"
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MobileTableSkeleton;
